/**
 * The different states of AJAX request
 */
export enum StoreObjectStatus {
	Pending = 'pending',
	Success = 'success',
	Error = 'error',
}

/**
 * Used for id-dictionary
 */
export class StoreObject<T> {
	public data: T | null = null;
	public error: any;
	public status: StoreObjectStatus = StoreObjectStatus.Pending;
}

/**
 * Used for paramsHash-dictionary
 */
export class StoreObjectList<T> {
	public data: T[] = [];
	public error: any;
	public status: StoreObjectStatus = StoreObjectStatus.Pending;
}
